import type { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';

import { AppProviders } from './components/AppProviders';
import { AppRouterErrorScreen } from './components/AppRouterErrorScreen';
import { AppShellScreen } from './components/AppShellScreen';
import { initializeWebObservability } from './lib/observability';
import { routeTree } from './routeTree.gen';

export function getRouter(input: { queryClient: QueryClient }) {
  const router = createRouter({
    context: {
      queryClient: input.queryClient,
    },
    defaultErrorComponent: AppRouterErrorScreen,
    defaultPendingComponent: AppShellScreen,
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    routeTree,
    scrollRestoration: true,
    Wrap: AppProviders,
  });

  initializeWebObservability({
    router,
  });

  return router;
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
